var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nqkoa",
    d: "M921 347h-9a3 3 0 0 0-3 3v32a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nqkob",
    d: "M931 377h-22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nqkoc",
    d: "M921 355h-12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nqkod",
    d: "M921 351h-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nqkoe",
    d: "M919 381h2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nqkof",
    d: "M938 359h10a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3h-20a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h3v6l7-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nqkog",
    d: "M915 351"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-908 -342)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#nqkoa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#nqkob"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#nqkoc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#nqkod"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#nqkoe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#nqkof"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#nqkog"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsBlue);
export default __webpack_public_path__ + "static/media/sms-blue.0416dcf185fb98a040367cc2f12255db.svg";
export { ForwardRef as ReactComponent };